import React from 'react';

import { usePriceRowContext } from '../../../price-row-context';

import StoreLogo from '@prisjakt/ui-store-logo';
import { StoreRatingAverage } from '../store-rating-average';

import { trackShopLogoClick } from '../../tracking';

import { SHOP_LOGO_WIDTH } from 'src/areas/store/constants';

import { VARIANTS, StoreInfo, StoreInfoTitle } from './styles';

export const StoreInfoColumn: React.FC<React.PropsWithChildren<
  React.PropsWithChildren<unknown>
>> = () => {
  const { isFeatured = false, offer } = usePriceRowContext();
  const { store } = offer;

  if (!store) {
    return null;
  }

  const handleShopLogoClick = () => trackShopLogoClick(store.id);

  const highResolutionLogo = store.logo
    ? { url: store.logo, width: SHOP_LOGO_WIDTH }
    : null;
  return (
    <StoreInfo role="none" onClick={handleShopLogoClick}>
      <StoreInfoTitle>{store.name}</StoreInfoTitle>
      <StoreLogo
        featured={isFeatured}
        hasImage={Boolean(store.hasLogo)}
        logoUrl={highResolutionLogo?.url}
        name={store.name}
        showHighResolutionLogo={Boolean(highResolutionLogo)}
        storeId={store.id}
        variant={VARIANTS.PRICE_LIST}
        width={highResolutionLogo?.width}
      />

      <StoreRatingAverage />
    </StoreInfo>
  );
};
